import AutocompleteElement from '@github/auto-complete-element'
import {fetchSafeDocumentFragment} from '@github-ui/fetch-utils'
import {on} from 'delegated-events'

function setLoading(container: Element, isLoading: boolean) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  container.querySelector<HTMLElement>('.js-add-child-team-loading-state')!.hidden = !isLoading
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  container.querySelector<HTMLElement>('.js-add-child-team-modal-content')!.hidden = isLoading
}

on('auto-complete-change', '.js-add-child-team-completer', async function ({target: completer}) {
  if (!(completer instanceof AutocompleteElement)) return
  if (!completer.value) return

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const container = completer.closest<HTMLElement>('.js-add-team-container')!
  setLoading(container, true)

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const form = completer.closest<HTMLElement>('.js-add-child-team-form')!
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const url = form.getAttribute('data-change-parent-summary-path')!
  const fragment = await fetchSafeDocumentFragment(document, url)
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  form.querySelector<HTMLElement>('.js-add-team-search')!.hidden = true
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  form.querySelector<HTMLElement>('.js-add-team-warning')!.append(fragment)
  setLoading(container, false)
})

on('submit', '.js-add-child-team-form', function (event) {
  const form = event.currentTarget
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const {value: completerValue} = form.querySelector<AutocompleteElement>('.js-add-child-team-completer')!

  if (!completerValue) {
    event.preventDefault()
  }
})

on('details-dialog-close', '.js-add-team-dialog', function (event) {
  const dialog = event.currentTarget
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const container = dialog.querySelector<HTMLElement>('.js-add-team-container')!

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  dialog.querySelector<HTMLElement>('.js-add-team-search')!.hidden = false
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  dialog.querySelector<HTMLElement>('.js-add-team-warning')!.textContent = ''
  setLoading(container, false)
})
